/* globals _ */

import api from './api';

const { noop } = _;

export default function( input, callback ) {
	callback = callback || noop;

	api( 'google/place/autocomplete', { input, components: 'country:ca' }, response => {
		callback( response.predictions, response.status );
	} );
}
